import React from 'react';
import './App.css';

function Input(props) {
	return (
		<form onSubmit={props.onSubmit}>
			<textarea
				className='Input'
				type="text"
				value={props.value}
				onChange={props.onChange}
				placeholder="Enter a skincare ingredient or copy-paste a comma separated list of ingredients directly from the product page."/>
			<input
				className="submitInput"
				type="submit"
				value="SEARCH" />
		</form>
	);
}

export default Input;



// WEBPACK FOOTER //
// ./src/Input.jsx